// import { User } from "@auth0/auth0-react";
import { IUser } from "../providers/auth-provider";
import Config from "./config";
import { UserDto } from "./dtos";
import React from "react";

export type UserProfile = {
  firstName: string;
  lastName: string;
  avatar: string;
};

const getUserRoles = (user: IUser | undefined): string[] => {   
  // return user?.[Config.auth0.roles_claims] ?? [];
  return user?.roles ?? [];
};

const isAdminRole = (user: IUser | undefined): boolean => {
  const roles: string[] = getUserRoles(user);
  return roles.includes('Admin Role')
};

const getUserMetadata = (user: IUser | undefined): UserProfile => {   
  //return user?.[Config.auth0.user_medatata_claims] ?? {};
  return user?.profile!;
};

const getUserProfile = (user: IUser | undefined, token: string): UserProfile => {
  const metadata: UserProfile = getUserMetadata(user);
  if (Object.keys(metadata).length === 0 && user) {
    const hasNoFirstLastName = !(user.given_name || user.family_name);
    const nickOrName = user.nickname ?? user.name;
    const result: UserProfile = {
      firstName: (user.given_name ?? (hasNoFirstLastName ? nickOrName : user.email)) ?? '',
      lastName: user.family_name ?? '',
      avatar: user.picture ?? ''
    };
    return result;
  }
  return metadata;
};

const buildMailto = (user: UserDto) => {
  const displayName = `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim();
  const subject = encodeURIComponent(`Message from ${Config.app_name} Admin`);
  const toField = encodeURIComponent(`${displayName} <${user.email}>`);
  const body = encodeURIComponent(`Hi ${user.first_name ?? 'there'},

I hope you're doing well.

I wanted to reach out to you regarding...

Best regards,
        ${Config.app_name} Admin`
    );
    return `mailto:${toField}?subject=${subject}&body=${body}`;
};

const emailLink = (user: UserDto): React.ReactNode => {
    return (<><a
            href={buildMailto(user)}
            onClick={(e) => e.stopPropagation()} // don’t trigger row selection
            style={{ color: "#0078d4", textDecoration: "underline", cursor: "pointer" }}
            title={`Email ${user.first_name} ${user.last_name}`}
        >
            {user.email}
        </a></>);
}

const formatUserName = (user: UserDto, includeEmail: boolean): React.ReactNode => {   
  const fullName: string = ((user.first_name ?? '') + ' ' + (user.last_name ?? '')).trim();
  if (fullName.length === 0) {
    return includeEmail ? emailLink(user) : user.email;
  }
  if (includeEmail) {
    const email: React.ReactNode = includeEmail ? emailLink(user) : user.email;
    return (<>{fullName}{' ('}{email}{')'}</>);
  }
  return fullName;
};

export { getUserRoles, isAdminRole, getUserMetadata, getUserProfile, buildMailto, formatUserName };